import { RichText } from "components/RichTextWidget";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Heading5, Icon, PageLink, Paragraph } from "shared/components";
import { formatDate } from "shared/utils";

import styles from "./Item.module.scss";

export const Item = ({ item }) => {
  const { locale } = useRouter();

  const date = useMemo(() => {
    return formatDate(item.date, locale);
  }, [item.date, locale]);

  return (
    <div className={styles.wrapper}>
      <PageLink link={item?.course} className={styles.link}>
        <div className={styles.item}>
          <div className={styles.text}>
            <Heading5 className={styles.title} color="dark">
              {item.title}
            </Heading5>
            <RichText className={styles.description} value={item.description} />
            {item.showDate && <Paragraph color="grey">{date}</Paragraph>}
          </div>
          <div className={styles.button}>
            <span className={styles.arrow}>
              <Icon className={styles.icon} name="arrow_right" />
            </span>
          </div>
        </div>
      </PageLink>
    </div>
  );
};
